// libs
import { useState } from "react";

// contexts
import { CroutonContextContextValue } from "@payment-client/contexts/CroutonContext";

const useCrouton = (): CroutonContextContextValue => {
    const [croutonState, setCroutonState] = useState<CroutonContextContextValue["croutonState"]>({
        title: "",
    } as CroutonContextContextValue["croutonState"]);

    return { croutonState, setCroutonState };
};

export default useCrouton;
